import { render, staticRenderFns } from "./AddProblemModal.vue?vue&type=template&id=1e753fa4&scoped=true"
import script from "./AddProblemModal.vue?vue&type=script&lang=js"
export * from "./AddProblemModal.vue?vue&type=script&lang=js"
import style0 from "./AddProblemModal.vue?vue&type=style&index=0&id=1e753fa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e753fa4",
  null
  
)

export default component.exports